export async function validateInput(fields) {
  const validations = await Promise.all(
    fields.map(
      async ({
        element,
        value,
        validate,
        characterLimit,
        disallowEmpty,
        secondErrorMsg,
      }) => {
        element.nextElementSibling.nextElementSibling.textContent = `${value.length}/${characterLimit}`;
        if ((value || disallowEmpty) && !(await validate(value))) {
          element.style.borderColor = "red";
          element.style.borderWidth = "2px";
          if (secondErrorMsg)
            element.nextElementSibling.nextElementSibling.nextElementSibling.style.display =
              "block";
          else element.nextElementSibling.style.display = "block";
          return false;
        }
        element.style.borderColor = null;
        element.style.borderWidth = null;
        if (secondErrorMsg)
          element.nextElementSibling.nextElementSibling.nextElementSibling.style.display =
            null;
        else element.nextElementSibling.style.display = null;
        return true;
      }
    )
  );
  const disable = validations.includes(false);
  return disable;
}
